import { ready } from '~/core'

ready('ratespageMenu', '.rates-page__list', (ratespageMenu) => {
  const links = ratespageMenu.querySelectorAll('.rates-page__list-link')
  links.forEach((item) => {
    item.addEventListener('click', function (e) {
      const links = ratespageMenu.querySelectorAll('.rates-page__list-link')
      links.forEach((link) => {
        link.classList.remove('active')
      })
      this.classList.add('active')
    })
  })

	// make menu scrollable if too tall  for window - header height
	let menuHeight;
	let headerHeight;
	const header = document.querySelector('header.header');
	const setMenuDims = () => {
		menuHeight = ratespageMenu.scrollHeight;
		headerHeight = header.getBoundingClientRect().height + Math.min(header.getBoundingClientRect().top, 0);
		const bufferSpace = 40;

		if (menuHeight > window.innerHeight - headerHeight - bufferSpace) {
			ratespageMenu.classList.add('scrollable');
			ratespageMenu.style.top = headerHeight + (bufferSpace / 2) + 'px';
			ratespageMenu.style.maxHeight = window.innerHeight - headerHeight - bufferSpace + 'px';
		} else {
			ratespageMenu.classList.remove('scrollable');
			ratespageMenu.style.top = '';
			ratespageMenu.style.maxHeight = '';
		}
	}

	setMenuDims();

	const throttleListener = (callback, time) => {
		let throttle = false;
		return () => {
			if (!throttle) {
				throttle = true;
				callback();
				setTimeout(() => {
					throttle = false;
				}, time);
			}
		}
	}

	window.addEventListener('resize', throttleListener(setMenuDims, 100));
	window.addEventListener('scroll', throttleListener(setMenuDims, 500));

	window.addEventListener('orientationchange', setMenuDims);
})
